export class VeerouteRequestPlanningDto {
	date: Date;
	requests: number[];
}
